import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'

import SuccessHandler from '../SuccessHandler'

/* private BrandConfigurationBranchOffice Types */
import {
  Settings,
  _BrandConfigurationBranchOffice
} from '../namespace-helper'

import _ from 'lodash'

const selectedBrandConfigurationBranchOfficeTemplate = {
  id: null,
  name: 'New Brand Branch Office',
  country: null,
  zipcode: null,
  city: null,
  hnumber: null,
  street: null,
  taxnumber: null,
  vat: null,
  district_court: null,
  iban: null,
  iban_currency: null,
  swift: null,
  commercial_register_number: null,
  default: false
}

export default {
  namespaced: true,
  state: {
    brandConfigurationBranchOffices: [],
    brandConfigurationBranchOfficesBankAccounts: [],
    allBrandConfigurationBranchOffices: [],
    selectedBrandConfigurationBranchOffice: _.cloneDeep(selectedBrandConfigurationBranchOfficeTemplate),
    openDialog: false
  },
  mutations: {
    [_BrandConfigurationBranchOffice.mutations.setBrandConfigurationBranchOffices] (state, payload) {
      state.brandConfigurationBranchOffices = payload
    },
    [_BrandConfigurationBranchOffice.mutations.setAllBrandConfigurationBranchOffices] (state, payload) {
      state.allBrandConfigurationBranchOffices = payload
    },
    [_BrandConfigurationBranchOffice.mutations.setSelectedBrandConfigurationBranchOffice] (state, payload) {
      if (payload !== null) {
        state.selectedBrandConfigurationBranchOffice = payload
      } else {
        state.selectedBrandConfigurationBranchOffice = _.cloneDeep(selectedBrandConfigurationBranchOfficeTemplate)
      }
    },
    [_BrandConfigurationBranchOffice.mutations.setAllBankAccountsOfBranchOffice] (state, payload) {
      if (payload !== null) {
        state.brandConfigurationBranchOfficesBankAccounts = payload
      }
    },
    [_BrandConfigurationBranchOffice.mutations.setOpenCloseDialogState] (state) {
      state.openDialog = !state.openDialog
    },
    [_BrandConfigurationBranchOffice.mutations.addNewBranchOffice] (state, payload) {
      if (state.brandConfigurationBranchOffices === null) {
        state.brandConfigurationBranchOffices = []
      }
      state.brandConfigurationBranchOffices.push(payload)
    },
    [_BrandConfigurationBranchOffice.mutations.addNewBankAccountToBrandConfiguration] (state, payload) {
      if (state.brandConfigurationBranchOfficesBankAccounts === null) {
        state.brandConfigurationBranchOfficesBankAccounts = []
      }
      state.brandConfigurationBranchOfficesBankAccounts.push(payload)
    },

    [_BrandConfigurationBranchOffice.mutations.removeBranchOffice] (state, payload) {
      state.brandConfigurationBranchOffices.splice(payload, 1)
    },

    [_BrandConfigurationBranchOffice.mutations.removeBranchOfficeBankAccountFromBrandConfiguration] (state, payload) {
      state.brandConfigurationBranchOfficesBankAccounts = state.brandConfigurationBranchOfficesBankAccounts.filter(
        obj => !(obj.iban === payload.iban)
      )
    }

  },
  actions: {

    [_BrandConfigurationBranchOffice.actions.loadAllBrandConfigurationBranchOfficesBankAccounts] (context, payload) {
      var url = API_URL + '/api/v1/brandConfigBranchBankAccounts'

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_BrandConfigurationBranchOffice.mutations.setAllBankAccountsOfBranchOffice, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_BrandConfigurationBranchOffice.actions.saveOrUpdateAdditionalBankAccount] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      if (payload.id) {
        let url = API_URL + '/api/v1/brandConfigBranchBankAccounts/' + payload.id
        // update state with put
        return axios.put(url, payload, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          ErrorHandler.clear(store)
          context.commit(_BrandConfigurationBranchOffice.actions.loadAllBrandConfigurationBranchOfficesBankAccounts)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      } else {
        let url = API_URL + '/api/v1/brandConfigBranchBankAccounts'
        return axios.post(url, payload, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          ErrorHandler.clear(store)
          context.commit(_BrandConfigurationBranchOffice.actions.loadAllBrandConfigurationBranchOfficesBankAccounts)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      }
    },
    [_BrandConfigurationBranchOffice.actions.saveBrandConfigurationBranchOffice] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      payload.forEach(function (v, i, o) {
        const data = JSON.stringify(v)

        if (v.id === null) {
          var url = API_URL + '/api/v1/brandConfigurationBranchOffices'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            ErrorHandler.clear(store)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/brandConfigurationBranchOffices/' + v.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            ErrorHandler.clear(store)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_BrandConfigurationBranchOffice.actions.loadBrandConfigurationBranchOffices] (context, payload) {
      console.log('brandConfigurationBranchOffices: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/brandConfigurationBranchOffices'

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_BrandConfigurationBranchOffice.mutations.setBrandConfigurationBranchOffices, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_BrandConfigurationBranchOffice.actions.loadAllBrandConfigurationCIs] (context, payload) {
      var url = API_URL + '/api/v1/brandConfigurationBranchOffices'

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_BrandConfigurationBranchOffice.mutations.setAllBrandConfigurationBranchOffices, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_BrandConfigurationBranchOffice.actions.removeBranchOffice] (context, payload) {
      const tempItems = context.getters.brandConfigurationBranchOffices
      const id = tempItems[payload].id

      if (id === null) {
        context.commit(_BrandConfigurationBranchOffice.mutations.removeBranchOffice, payload)
        return
      }

      var url = API_URL + '/api/v1/brandConfigurationBranchOffices/' + id

      console.log('removeBranchOffice: ' + id)

      store.commit(Settings.mutations.setLoading, true)

      axios.delete(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        ErrorHandler.clear(store)
        context.commit(_BrandConfigurationBranchOffice.mutations.removeBranchOffice, payload)
        SuccessHandler.handleApiSuccess(store, r.data.message)
        store.commit(Settings.mutations.setLoading, false)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
        store.commit(Settings.mutations.setLoading, false)
      }).catch(e => console.error('#### ' + e))
    },
    [_BrandConfigurationBranchOffice.actions.openCloseDialog] ({ commit }) {
      commit(_BrandConfigurationBranchOffice.mutations.setOpenCloseDialogState)
    },
    [_BrandConfigurationBranchOffice.actions.setSelectedBrandConfigurationBranchOffice] ({ commit }, payload) {
      commit(_BrandConfigurationBranchOffice.mutations.setSelectedBrandConfigurationBranchOffice, payload)
    },
    [_BrandConfigurationBranchOffice.actions.addNewBranchOffice] ({ commit }, payload) {
      commit(_BrandConfigurationBranchOffice.mutations.addNewBranchOffice, payload)
    },
    [_BrandConfigurationBranchOffice.actions.addNewBankAccountToBrandConfiguration] ({ commit }, payload) {
      commit(_BrandConfigurationBranchOffice.mutations.addNewBankAccountToBrandConfiguration, payload)
    },
    [_BrandConfigurationBranchOffice.actions.removeBranchOfficeBankAccountFromBrandConfiguration] (context, payload) {
      var url = API_URL + '/api/v1/brandConfigBranchBankAccounts/' + payload.id

      store.commit(Settings.mutations.setLoading, true)

      axios.delete(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        ErrorHandler.clear(store)
        context.commit(_BrandConfigurationBranchOffice.mutations.removeBranchOfficeBankAccountFromBrandConfiguration, payload)
        SuccessHandler.handleApiSuccess(store, r.data.message)
        store.commit(Settings.mutations.setLoading, false)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
        store.commit(Settings.mutations.setLoading, false)
      }).catch(e => console.error('#### ' + e))
      // commit(_BrandConfigurationBranchOffice.mutations.removeBranchOfficeBankAccountFromBrandConfiguration, payload)
    },
    [_BrandConfigurationBranchOffice.actions.resetState] ({ commit }, payload) {
      commit(_BrandConfigurationBranchOffice.mutations.setBrandConfigurationBranchOffices, [])
      commit(_BrandConfigurationBranchOffice.mutations.setAllBrandConfigurationBranchOffices, [])
      commit(_BrandConfigurationBranchOffice.mutations.setSelectedBrandConfigurationBranchOffice, null)
    }
  },
  getters: {
    [_BrandConfigurationBranchOffice.getters.brandConfigurationBranchOffices] (state) {
      return state.brandConfigurationBranchOffices
    },
    [_BrandConfigurationBranchOffice.getters.getAllBrandConfigurationBranchOfficesBankAccounts] (state) {
      return state.brandConfigurationBranchOfficesBankAccounts
    },
    [_BrandConfigurationBranchOffice.getters.getAllBrandConfigurationBranchOffices] (state) {
      return state.allBrandConfigurationBranchOffices
    },
    [_BrandConfigurationBranchOffice.getters.getOpenDialogState] (state) {
      return state.openDialog
    },
    [_BrandConfigurationBranchOffice.getters.getSelectedBrandConfigurationBranchOffice] (state) {
      return state.selectedBrandConfigurationBranchOffice
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/BrandConfiguration/brandConfigurationsBranchOffices.js